<template>
	<div class="home" v-if="shop">
		<van-nav-bar
		  	:title="$t('ShopInfo.title')"
            left-arrow
            fixed
            :z-index=9
            @click-left="$router.back()">
		</van-nav-bar>
        <div style="width: 100%;border-top: 1px solid #f3f3f3;padding-top:46px">
            <van-image
                v-if="shop.image"
                width="100%"
                fit="contain"
                :src="shop.image.path"
            />
        </div>
        <van-cell-group>
            <van-cell icon="./static/img/shopname.png" class="info" size="20px" :title="$t('ShopInfo.name')" :value="shop.name"/>
            <van-cell icon="./static/img/local.png" class="info" size="20px" :title="$t('ShopInfo.address')" :value="shop.address"/>
            <van-cell icon="./static/img/tele.png" class="info" size="20px" :title="$t('ShopInfo.phone')" :value="shop.phone"/>
            <van-cell v-if="shop.after_start" icon="./static/img/Business_time.png" class="info" size="20px" :title="$t('ShopInfo.time')" :value="shop.start_time+'-'+shop.after_start+' '+shop.after_end+'-'+shop.end_time"/>
            <van-cell v-else icon="./static/img/Business_time.png" class="info" size="20px" :title="$t('ShopInfo.time')" :value="shop.start_time+'-'+shop.end_time"/>

            <van-field
                :value="shop.intro"
                type="textarea"
                autosize
                readonly
                clearable
                class="fr"
                left-icon="./static/img/introduction.png"
                :label="$t('ShopInfo.intro')"
                />
        </van-cell-group>
	</div>
</template>

<script>
export default {
    data () {
      	return {
            shop:{},
      	}
    },
    mounted:function(){
        this.getShopInfo();
    },
    methods:{
        getShopInfo(){
            // 获取门店详情
            this.$axios({
                method: 'GET',
                headers: {
                    'type':sessionStorage.type,
                    'code':sessionStorage.code,
                    'placeid':sessionStorage.placeId,
                },
                url: this.$build+'/api/store/'+this.$route.params.id+'/customerShow',
            }).then(res => {
                console.log(res);
                if(res.data.status==200){
                    this.shop=res.data.data;
                }else{
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
            }).catch(err => {
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
        },
    }
}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 26px;
		color: #fff;
	}
    /deep/ .fr textarea{
        text-align: right;
    }
    /deep/ .info  size="20px".van-cell__value span{
        color: #000;    
    }
    /deep/ .van-cell__value {
        color: #323233;
    }
	.home{
		width: 100%;
		height: 100vh;
		background-color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/ShopInfo.vue